import { __ } from '@wordpress/i18n';
import {
	TextControl,
} from '@wordpress/components';
import ColorControl from '../../../controls/ColorControl';
const Languages = ({ item, index, itemIndex, handleChangeItemField, setAttributes, attributes }) => {
	const {
		languageNameColor,
		languagePercentageColor,
		languageProgressTopColor,
		languageProgressBottomColor,
		style,
	} = attributes || {};
	return (
		<>
			<TextControl
				label={__('Language Name', 'cv-builder')}
				value={item.name || ''}
				onChange={(value) =>
					handleChangeItemField(value, index, itemIndex, 'name')
				}
			/>
			{item.percentage !== undefined && (
				<TextControl
					label={__('Language Percentage', 'cv-builder')}
					value={item.percentage || 0}
					type="number"
					min={0}
					max={100}
					step={1}
					onChange={(value) => handleChangeItemField( Number(value), index, itemIndex, 'percentage' )}
				/>
			)}
			{
				style !== 'style26' && style !== 'style27' && style !== 'style28' && (
					<>
					<ColorControl
						label={__(
						'Name Color',
						'cv-builder'
						)}
						color={	languageNameColor}
						colorName="languageNameColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
					<ColorControl
						label={__(
						'Percentage Color',
						'cv-builder'
						)}
						color={languagePercentageColor}
						colorName="languagePercentageColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
					<ColorControl
						label={__(
						' Progress Top Background Color',
						'cv-builder'
						)}
						color={languageProgressTopColor}
						colorName="languageProgressTopColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
					<ColorControl
						label={__(
						'Progress Bottom Background Color',
						'cv-builder'
						)}
						color={languageProgressBottomColor}
						colorName="languageProgressBottomColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
				</>
				)
			}
		</>
	);
};

export default Languages;
